import { localize, setInteractionMode, extend } from 'vee-validate';
import pt_BR from './locale/pt_BR.json';

/*
 * Localizations.
 */
localize('pt_BR', pt_BR)

/*
 * Interaction modes.
 */
setInteractionMode('lazy-change', () => ({ on: ['change'] }))

/*
 * Rules.
 */
import * as veeValidateRules from 'vee-validate/dist/rules';
import * as customRules from './rules'
import * as customRulesProntoAtendimentoPlantao from './rules/pronto-atendimento/plantao'

const rules = Object.assign({},
    veeValidateRules,
    customRules,
    customRulesProntoAtendimentoPlantao,
)

Object.keys(rules).forEach(rule => extend(rule, rules[rule]))
